import { render } from "./main_purchase.vue?vue&type=template&id=5e677372&scoped=true"
import script from "./main_purchase.vue?vue&type=script&lang=js"
export * from "./main_purchase.vue?vue&type=script&lang=js"

import "./main_purchase.vue?vue&type=style&index=0&id=5e677372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e677372"]])

export default __exports__